import angular from 'angular'

import StrictObj from './strict-obj'

import { has } from 'lodash-es'

angular
  .module('ggs.utils')
  .factory('pluralize', pluralizeProvider)

const CATEGORIES = StrictObj({
  ONE: 'one',
  OTHER: 'other'
})

function pluralizeProvider() {
  return function pluralize(when, count, offset = 0) {
    const toLookup = count - offset
    const category = toLookup === 1 ? CATEGORIES.ONE : CATEGORIES.OTHER
    const rule = has(when, toLookup)
      ? when[toLookup]
      : when[category]

    return rule(count)
  }
}
